import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, EMPTY, map, tap, catchError, throwError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "src/app/modules/auth";
import { TranslationService } from "src/app/modules/i18n";
import { UiHelperService } from "./ui-helper.service";

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  pendingRequests: number = 0;
  environmentVariables: any;

  constructor(
    public auth: AuthService,
    private router: Router,
    private translate:TranslationService,
    private uiHelper:UiHelperService
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Clone the request to add the new header.
    if (this.auth.getToken()) {
      req = req.clone({
        setHeaders: {
          'Accept-Language':this.translate.getSelectedLanguage(),
          Authorization: `Bearer ${this.auth.getToken()}`,
        },
      });
    }

    //send the newly created request
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        // Handle successful HTTP responses
        if (event instanceof HttpResponse) {
          // console.log('Response received:', event);
          // Process the response if needed
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Handle unauthorized error
          this.auth.removeToken();
          this.router.navigate(['/','auth','login']);
        } else if (error.status === 400) {
          //bad request here
        }else if(error.status === 403){
          this.uiHelper.toastrError('Permission needed')
          this.router.navigate(['/']);
        }else if (error.status === 404) {
          this.uiHelper.toastrError('Not Found');
        }
        // Pass the error to the caller
        return throwError(() => error);
      })
    );
  }
}